import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  backgroundContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    zIndex: -1,
    overflow: 'hidden',
  },
  videoSection: {
    position: 'relative',
    width: '1440px',
    height: 'auto',
    minHeight: '665px',
    zIndex: 1,
    left: '50%',
    transform: 'translate(-50%, -0)',
  },
  video: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    display: 'block',
  },
  videoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
    linear-gradient(270deg, #151117 0%, rgba(21, 17, 23, 0) 22.6%),
    linear-gradient(270deg, rgba(21, 17, 23, 0) 77.4%, #151117 100%),
    linear-gradient(180deg, rgba(21, 17, 23, 0.4) 0%, #151117 100%)
  `,
    backgroundBlendMode: 'normal',
    pointerEvents: 'none',
    zIndex: 1,
  },
  imageWrapper: {
    position: 'relative',
    // inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  backgroundImage: {
    maxWidth: 'none',
    position: 'absolute',
    left: '50%',
    top: 0,
    transform: 'translate(-50%, 0)',
    pointerEvents: 'none',
  },
}));

export default useStyles;
